
import { BrowserRouter } from 'react-router-dom';
import { RouterProvider } from './router';
import { ThemeProvider } from './hooks/useTheme';
import { LanguageProvider } from './hooks/useLanguage';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <RouterProvider />
        </BrowserRouter>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
